import { z } from 'zod';
export const CompilationSourceSchema = z.enum([
    'cli_deploy',
    'refresh_dbt',
    'create_project',
]);
//# sourceMappingURL=projectCompileLogs.js.map